import { MUTATION_TYPES } from './mutations';

const ACTION_TYPES = {
  SET_CONFIG: 'setConfig',
  SET_LD_FLAGS: 'setLDFlags',
  SET_LOCALE: 'setLocale',
};

const actions = {
  [ACTION_TYPES.SET_CONFIG]: async ({ commit }, { apps, groups, disabledApps } = {}) => {
    commit(MUTATION_TYPES.SET_APPS, apps);
    commit(MUTATION_TYPES.SET_GROUPS, groups);
    commit(MUTATION_TYPES.SET_DISABLED_APPS, disabledApps);
  },
  [ACTION_TYPES.SET_LD_FLAGS]: async ({ commit }, flags) => {
    commit(MUTATION_TYPES.SET_LD_FLAGS, flags);
  },
  [ACTION_TYPES.SET_LOCALE]: async ({ commit }, locale) => {
    commit(MUTATION_TYPES.SET_LOCALE, locale);
  },
};

export {
  actions,
  ACTION_TYPES,
};
